const plates = {
  SMK: "Somolu",
  JJJ: "Ojo",
  KJA: " Ikeja",
  AAA: "Lagos Island",
  FKJ: "Ifako Ijaiye",
  AKD: "Ibeju Lekki",
  LND: "Lagos Mainland",
  LSR: "Surulere",
  LSD: "Oshodi Isolo",
  KSF: "Kosofe",
  AGL: "Ajeromi Ifelodun",
  APP: "Apapa",
  KTU: "Ketu",
  BDG: "Badagry",
  EKY: "Eti-Osa",
  KRD: "Ikorodu",
  EPE: "Epe",
  MUS: "Mushin",
  GGE: "Agege",
  FST: "Festac",
}

module.exports = plates
